import { useState } from 'react';
import { NavLink } from 'react-router-dom';

const NAV_LINKS = [
  { label: 'La carte', to: '/la-carte' },
  { label: 'Notre engagement', to: '/notre-concept' },
  { label: 'Contact', to: '/contact' },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <header
        style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 50, width: '100%', height: '80px', backgroundColor: '#fff', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}
      >
        <div className="max-container header-inner" style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingLeft: '48px', paddingRight: '48px', boxSizing: 'border-box' }}>
          {/* Logo */}
          <a href="/" onClick={() => setOpen(false)}>
            <img src="/logo.svg" alt="Four a Tacos" style={{ width: '50px', height: '50px', objectFit: 'contain' }} />
          </a>

          {/* Navigation desktop */}
          <nav className="header-nav-links" style={{ display: 'flex', alignItems: 'center', gap: '40px' }}>
            {NAV_LINKS.map(({ label, to }) => (
              <NavLink
                key={to}
                to={to}
                end
                style={{ fontFamily: 'Code Pro Black, sans-serif', fontSize: '16px', textDecoration: 'none', textTransform: 'uppercase', paddingBottom: '4px' }}
                className={({ isActive }) => isActive ? 'nav-active' : 'nav-inactive'}
              >
                {label}
              </NavLink>
            ))}
          </nav>

          {/* Hamburger mobile */}
          <button className="hamburger" onClick={() => setOpen(o => !o)} aria-label="Menu">
            {open ? (
              <span style={{ fontSize: '36px', lineHeight: 1, color: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '24px', height: '16px', background: 'none', border: 'none', borderRadius: 0 }}>✕</span>
            ) : (
              <>
                <span />
                <span />
                <span />
              </>
            )}
          </button>
        </div>
      </header>

      {/* Mobile nav */}
      <nav className={`mobile-nav${open ? ' open' : ''}`}>
        {NAV_LINKS.map(({ label, to }) => (
          <NavLink
            key={to}
            to={to}
            className="mobile-nav-link"
            onClick={() => setOpen(false)}
          >
            {label}
          </NavLink>
        ))}
      </nav>
    </>
  );
}
